module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAUCAYAAABxnDbHAAABXUlEQVRIicXWv05UQRTH8c+ONxDkTwGlJFrxBIaE0NPRobE3MTbwANDsVL4C6hMYeA1Cgj4BNhC0hBCEJShwLO5uNLqRe6+b5ZdMNb8z38nJnDOnFRG6eoEVPMZDjOMBJv2tEYzhEt/77H/DDS7QwSG2cs4fQESIiLUYjlbb7bZWREzgK6b63HjQOsOjhOUhAXU5ywmLFQOucTwA8GLCXEXzRdf7FnGH91+aS5itEXCC15jHXkPobMJMg8BPWMAr9VM+kzDaAAq3eK9+ykcTioZQkHM+yTn3Uv6xQkiR/gfYWBFxWrGbnEbZvf5c0xGxGRG3Vc8pcNXwvgkv8Ua9x3iVNCv4p9jFu5pAOE44qhEwjU1ljc7XhPX0pcBnLFUwj2Nfs7r+XfsJOxXNxQCAsHNvX9s51ocAhI2c83krfo0rz/AcTzChHEfuGlc6+NFn/0zZJjvK3+kA271x5Sex7SgFh81P3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/youtube.png
// module id = 211
// module chunks = 0